import React from 'react';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import AdminListToolbar from './AdminListToolbar';
import useAdminRouteMeta from '../../hooks/useAdminRouteMeta';

/**
 * Contenedor plano para vistas admin (sin tarjeta flotante).
 * Búsqueda/fechas: en el encabezado de la página (según ruta o props).
 */
const AdminPageShell = ({
  title,
  actions,
  children,
  fullHeight = false,
  showSearch,
  showDateFilter,
}) => {
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
  const routeMeta = useAdminRouteMeta();

  const enableSearch = showSearch ?? routeMeta.showSearch ?? false;
  const enableDateFilter = showDateFilter ?? routeMeta.showDateFilter ?? false;
  const hasToolbar = enableSearch || enableDateFilter;
  const hasHeader = title || actions || hasToolbar;

  return (
    <Box
      w="100%"
      h={fullHeight ? '100%' : undefined}
      minH={fullHeight ? 0 : undefined}
      display={fullHeight ? 'flex' : undefined}
      flexDirection={fullHeight ? 'column' : undefined}
      overflow={fullHeight ? 'hidden' : undefined}
    >
      {hasHeader && (
        <Box
          pb={2}
          mb={2}
          borderBottom="1px solid"
          borderColor={borderColor}
          flexShrink={0}
        >
          <Flex
            align={{ base: 'stretch', md: 'center' }}
            justify="space-between"
            gap={3}
            flexDirection={{ base: 'column', md: 'row' }}
          >
            {title ? (
              <Text
                fontSize={{ base: 'md', md: 'lg' }}
                fontWeight="semibold"
                color="gray.800"
                flexShrink={0}
                noOfLines={1}
              >
                {title}
              </Text>
            ) : (
              <Box />
            )}
            <Flex
              align="center"
              gap={2}
              flexWrap="wrap"
              justify={{ base: 'flex-start', md: 'flex-end' }}
              flex="1"
            >
              {hasToolbar && (
                <AdminListToolbar
                  showSearch={enableSearch}
                  showDateFilter={enableDateFilter}
                />
              )}
              {actions && <Flex gap={2} flexShrink={0}>{actions}</Flex>}
            </Flex>
          </Flex>
        </Box>
      )}
      <Box
        flex={fullHeight ? 1 : undefined}
        minH={fullHeight ? 0 : undefined}
        minW={0}
        maxW="100%"
        h={fullHeight ? '100%' : undefined}
        overflow={fullHeight ? 'hidden' : undefined}
        display={fullHeight ? 'flex' : undefined}
        flexDirection={fullHeight ? 'column' : undefined}
        bg={fullHeight ? 'white' : undefined}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AdminPageShell;
